import React from 'react';
import _ from 'lodash';
import CarouselSection from 'screens/ContentDetail/components/CarouselSection';
import PropTypes from 'prop-types';
import Divider from '../Divider';
import Style from './Recommended.module.scss';

const Recommended = ({
  breakpoint,
  collectionCount,
  isAnonymous,
  recommended = {},
  seriesType,
  overrideAdditionalPosterStyle,
  verticalPosition,
}) => {
  const panelProps = {
    breakpoint,
    collectionCount,
    overrideAdditionalPosterStyle,
    seriesType,
    isSeriesDetailAnonymous: false,
    verticalPosition,
  };

  if (!_.isEmpty(recommended)) {
    return (
      <>
        <div className={Style.recommendedCarousel}>
          <CarouselSection
            isAnonymous={isAnonymous}
            dropdownHeadline={recommended?.headline}
            isPosters
            isSeasons
            panel={recommended}
            {...panelProps}
          />
        </div>
        <Divider />
      </>
    );
  }

  return null;
};

Recommended.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  collectionCount: PropTypes.number,
  isAnonymous: PropTypes.bool,
  overrideAdditionalPosterStyle: PropTypes.bool,
  recommended: PropTypes.shape({}),
  seriesType: PropTypes.string.isRequired,
  verticalPosition: PropTypes.number,
};

export default React.memo(Recommended);
